import { useEffect, useState } from "react";
import { createNewCredentialsForStore, getAllUser, updateStore } from "../../services/AllServices";
import { showMessage } from "../../utils/helpers";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { CreateNewCredentialValidation, ResetPasswordValidation } from "../../pages/Home/Validations";

const useCreateNewViewController = () => {
  const [userList, setUserlist] = useState([]);
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [generatedUsername, setGeneratedUsername] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const { setFieldValue, handleSubmit, errors, values, touched } = useFormik({
    initialValues: {
      password: generatedPassword ? generatedPassword : "",
      confirmPassword: "",
      selectedEmployee: "",
    },
    validationSchema: state?.created
      ? CreateNewCredentialValidation
      : ResetPasswordValidation,

    onSubmit: async (values) => {
      try {
        let sendbody;
        let responseData;
        if (state?.created) {
          sendbody = {
            sid: id,
            approver_id: values?.selectedEmployee,
          };
          responseData = await createNewCredentialsForStore(sendbody);
        } else {
          sendbody = {
            reset_password: true,
          };
          responseData = await updateStore(id, sendbody);
        }
        setGeneratedPassword(responseData?.password);
        setGeneratedUsername(responseData?.name);
        setShowModal(true);
      } catch (error) {
        showMessage("error", error?.response?.data?.message || "Something went wrong");
      }
    },
  });
  const handleSelectedEmployee = (e) => {
    if (e) {
      setFieldValue('selectedEmployee', e?.value);
    } else {
      setFieldValue('selectedEmployee', '');
    }
  };

  const goBack = () => {
    navigate('/home')
  };
  useEffect(() => {
    const fetchUserList = async () => {
      try {
        let responseData = await getAllUser();
        responseData = responseData?.data?.users?.filter((e) => e?.role === "supervisor");
        setUserlist(
          responseData?.map((e) => ({
            id: e?.id,
            label: e?.username,
            role: e?.role,
            value: e?.id,
          })) || []
        );
      } catch (error) {
        window.alert(error?.response?.data?.message || "Something went wrong");
      }
    };
    fetchUserList();
  }, []);

  useEffect(() => {
    setFieldValue("password", generatedPassword);
    setFieldValue("name", generatedUsername);
  }, [generatedPassword, generatedUsername, setFieldValue]);


  return {
    goBack,
    state,
    handleSubmit,
    userList,
    values,
    handleSelectedEmployee,
    touched,
    errors,
    showModal,
    setShowModal,
    generatedUsername,
    generatedPassword,
  }
}
export default useCreateNewViewController;